<template>
  <el-row :gutter="10">
    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
      <el-card>
        <div id="myChart" :style="{ width: '100%', height: '65vh' }"></div>
      </el-card>
      <el-card v-show="visible">
        <el-divider content-position="left"> ③ 简要结果</el-divider>
        <div style="text-align: left">
          <div>
            {{ currentTime }},患儿{{ form.name }},登记号{{form.id}}，年龄{{
              age
            }},最后一次测量时间为{{ lastCheck }}。遗传身高为{{
              geneticHeight
            }}cm,{{ tooltips }}。
          </div>
          <div style="color: grey">报告ID:{{ reportId }}</div>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
      <el-card>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-position="right"
          label-width="80px"
          size="mini"
        >
          <el-divider content-position="left"> ① 患儿基本信息</el-divider>
          <el-form-item label="登记号" required>
            <el-input v-model="form.id"></el-input>
          </el-form-item>
          <el-form-item label="患儿姓名" required>
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="性别" required>
            <el-radio v-model="form.gender" :label="1">男</el-radio>
            <el-radio v-model="form.gender" :label="0">女</el-radio>
          </el-form-item>
          <el-form-item label="生日" prop="birthday">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.birthday"
              style="width: 100%"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="低预期">
            <el-switch v-model="form.short"></el-switch>
          </el-form-item>
          <el-form-item label="骨龄" prop="born">
            <el-col :span="4"
            >
              <el-input
                v-model.number="form.boneYear"
                placeholder="年"
              ></el-input
              >
            </el-col>
            <el-col :span="1">
              <div>年</div>
            </el-col>
            <el-col :span="4"
            >
              <el-input
                v-model.number="form.boneMonth"
                placeholder="月"
              ></el-input
              >
            </el-col>
            <el-col :span="1">
              <div>月</div>
            </el-col>
          </el-form-item>
          <el-form-item label="父亲身高" prop="fatherHeight">
            <el-input
              v-model.number="form.fatherHeight"
              type="number"
              :step="0.01"
              placeholder="请输入身高(cm)"
            ></el-input>
          </el-form-item>
          <el-form-item label="母亲身高" prop="motherHeight">
            <el-input
              v-model.number="form.motherHeight"
              type="number"
              :step="0.01"
              placeholder="请输入身高(cm)"
            ></el-input>
          </el-form-item>
          <el-divider content-position="left"> ② 身高(cm)及记录时间</el-divider>
          <!-- 动态添加患者身高数据 -->
          <el-form-item
            :inline="true"
            v-for="(height, index) in form.patientHeight"
            :label="'第' + (index + 1) + '次'"
            :key="height.key"
          >
            <!-- 易错 :prop="'patientHeight.' + index + '.value'"  -->
            <el-col :span="6">
              <el-form-item
                :prop="'patientHeight.' + index + '.value'"
                :rules="{
                  required: true,
                  message: '身高不能为空',
                  trigger: 'blur',
                }"
                required
              >
                <el-input
                  v-model.number="height.value"
                  type="number"
                  :step="0.01"
                  placeholder="身高(cm)"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :prop="'patientHeight.' + index + '.time'"
                :rules="{
                  type: 'date',
                  required: true,
                  message: '请选择日期',
                  trigger: 'change',
                }"
                required
              >
                <el-date-picker
                  type="date"
                  placeholder="选择日期"
                  v-model="height.time"
                  style="width: 100%"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-select
                :prop="'patientHeight.' + index + '.treatment'"
                v-model="height.treatment"
                placeholder="治疗方式"
                required>
                <el-option
                  v-for="treatment in treatments"
                  :key="treatment.value"
                  :label="treatment.label"
                  :value="treatment.value">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="2">
              <el-button @click.prevent="removeHeight(height)">删除</el-button>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-button @click="addHeight" type="primary" icon="el-icon-edit"
            >新增身高纪录
            </el-button
            >
            <el-button @click="save_patient_form" type="primary" icon="el-icon-edit"
            >保存身高纪录
            </el-button
            >
            <el-button @click="load_patient_form_by_id" type="primary" icon="el-icon-edit"
            >加载身高纪录
            </el-button
            >
            <el-button
              type="success"
              @click="submitForm('form')"
              icon="el-icon-finished"
            >预测
            </el-button
            >
            <!-- <el-button @click="test">test</el-button> -->
            <el-button
              @click="resetForm('form')"
              type="warning"
              icon="el-icon-delete"
            >重置
            </el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import * as echarts from "echarts";
import standardHeight from "./height.json";

export default {
  name: "Index",
  data() {
    return {
      standardHeight: standardHeight,
      myChart: null,
      treatments: [{
        value: 0,
        label: '无治疗'
      }, {
        value: 1,
        label: '单生长激素'
      }, {
        value: 2,
        label: '单抑制针'
      }, {
        value: 3,
        label: '双打'
      }, {
        value: 4,
        label: '双打+来曲唑'
      }],
      form: {
        // 登记号和姓名
        id:null,
        name: null,
        // 0 男 1 女
        gender: 1,
        birthday: null,
        // 骨龄 x 年 y 月
        boneYear: null,
        boneMonth: null,
        // 父母身高
        fatherHeight: null,
        motherHeight: null,
        // 有影响身高的因素,默认无
        short: false,
        patientHeight: [{value: "", key: 1, time: null, treatment: 0}]
      },
      // 患儿身高，依次为month,height,heightIndex,tips,createdTimeStr,treatment
      heightList: [],
      heightPredictList: [],
      // 在mounted 中初始化当前时间
      currentTime: null,
      // 在 calHeightList 中计算年龄
      age: null,
      // 在 calHeightList 中计算末次检查时间
      lastCheck: null,
      // 在 calHeightList 中计算,把tooltip 的提示再显示一遍
      tooltips: null,
      // tooltips 的 card 页面显示与否
      visible: false,
      // 遗传身高
      geneticHeight: null,
      rules: {
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        birthday: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ]
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      reportId: null
    };
  },
  mounted() {
    // 初始化echarts
    this.myChart = echarts.init(document.getElementById("myChart"));
    // 不能把this.myChart直接传入函数里
    var myChart = this.myChart;
    window.onresize = function () {
      myChart.resize();
    };
    this.drawLine();
    var d = new Date();
    this.currentTime =
      d.getFullYear() + "年" + (d.getMonth() + 1) + "月" + d.getDate() + "日";
  },
  methods: {
    drawLine() {
      // 绘制图表
      this.myChart.setOption({
        title: {text: ""},
        legend: {
          // Try 'horizontal'
          // orient: 'vertical',
          // right: 10,
          // bottom: 80,
          show: false
        },
        // 设置图表的内边距
        grid: {
          x: 20,
          y: 30,
          x2: 30,
          y2: 30
        },
        // 对Y周内容解析，格式化点的显示内容
        tooltip: {
          trigger: "item",
          textStyle: {
            align: "left"
          },
          formatter: params => {
            // 数据为 params.data，里面有时间name，时间(m)身高(cm)坐标value,预测身高，身高相关提示tips
            // 只有写成这种格式(params) =>才能调用vue的函数
            // data.value为列表，依次为month,height,heightIndex,tips,createdTimeStr
            var month = params.data.value[0];
            var height = params.data.value[1];
            var SD = params.data.value[2];
            var height18 = params.data.value[3];
            var heightMid = params.data.value[4];
            var name = this.form.name;
            var tip =
              "姓名:" +
              name +
              "<br/>年龄:约" +
              parseInt(month / 12) +
              "岁" +
              (month % 12) +
              "月<br/>" +
              "身高:" +
              height +
              "cm<br/>" +
              "当前身高距离平均值:" +
              heightMid +
              "cm<br/> " +
              "标准差:" +
              SD +
              "<br/> 18岁预测身高:" +
              height18 +
              "cm";
            return tip;
          }
        },
        // 设置数值到图像的映射
        // todo: 暂不可用，visual map on line style only support x or y dimension
        visualMap: [
          {
            show: false,
            seriesIndex: 0,
            // treatment不在列表前2个位置，线条的颜色不会改变
            dimension: 5, // series.data 的第6个维度（即 value[5]）被映射
            categories: [0, 1, 2, 3, 4],
            inRange: {
              symbolSize: 5,
              symbol: {
                0: 'diamond',
                '': 'circle'
              }
            },
          }
        ],
        xAxis: {
          type: "value",
          name: "",
          symbol: "arrow",
          // 横轴是月份，所以刻度计算时要乘以12
          // min: 12 * 12,
          max: 18 * 12,
          interval: 12,
          linestyle: {
            type: "dash"
          },
          splitLine: {
            show: true
          },
          // 轴的标签，横轴是月，在这里转为岁
          axisLabel: {
            formatter: function (value, index) {
              return parseInt(value / 12) + "岁";
            },
            rotate: 45
          },
          //自适应
          scale: true
        },
        yAxis: {
          type: "value",
          name: "身高 cm",
          symbol: "arrow",
          linestyle: {
            type: "dash"
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            formatter: "{value}",
            rotate: 45
          },
          //y轴放到右边
          position: "right",
          axisLine: {onZero: false},
          // min: 140,
          // max: 150
          interval: 20,
          splitNumber: 5
        },
        series: [
          // 排序决定了tooltip的显示顺序
          {
            name: "患儿身高",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: true,
            lineStyle: {
              width: 2,
              type: "solid" //'dotted'虚线 'solid'实线
            },
            tooltip: {
              valueFormatter: value => value + " cm"
            },
            // data为列表，依次为month,height,heightIndex,tips,createdTimeStr,treatment
            data: this.heightList
          },
          {
            name: "预测身高虚线",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: false,
            lineStyle: {
              width: 2,
              type: "dotted" //'dotted'虚线 'solid'实线
            },
            tooltip: {
              valueFormatter: value => value + " cm"
            },
            // data为列表，依次为month,height,heightIndex,tips,createdTimeStr
            data: this.heightPredictList
          },
          {
            name: "+3SD身高",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: false,
            lineStyle: {
              width: 2,
              type: "solid", //'dotted'虚线 'solid'实线
              opacity: 0.3
            },
            data: this.standardHeight[this.form.gender].p3SD
          },
          {
            name: "+2SD身高",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: false,
            lineStyle: {
              width: 2,
              type: "solid", //'dotted'虚线 'solid'实线
              opacity: 0.3
            },
            data: this.standardHeight[this.form.gender].p2SD
          },
          {
            name: "+1SD身高",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: false,
            lineStyle: {
              width: 2,
              type: "solid", //'dotted'虚线 'solid'实线
              opacity: 0.3
            },
            // data为列表，依次为month,height,heightIndex,tips,createdTimeStr
            data: this.standardHeight[this.form.gender].p1SD
          },
          {
            name: "标准身高",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: false,
            lineStyle: {
              width: 2,
              type: "solid", //'dotted'虚线 'solid'实线
              opacity: 0.3
            },
            // data为列表，依次为month,height,heightIndex,tips,createdTimeStr
            data: this.standardHeight[this.form.gender].medium
          },
          {
            name: "-1SD身高",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: false,
            lineStyle: {
              width: 2,
              type: "solid", //'dotted'虚线 'solid'实线
              opacity: 0.3
            },
            // data为列表，依次为month,height,heightIndex,tips,createdTimeStr
            data: this.standardHeight[this.form.gender].m1SD
          },
          {
            name: "-2SD身高",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: false,
            lineStyle: {
              width: 2,
              type: "solid", //'dotted'虚线 'solid'实线
              opacity: 0.3
            },
            // data为列表，依次为month,height,heightIndex,tips,createdTimeStr
            data: this.standardHeight[this.form.gender].m2SD
          },
          {
            name: "-3SD身高",
            type: "line",
            smooth: true,
            // 示例数据的曲线上 显示 点
            showSymbol: false,
            lineStyle: {
              width: 2,
              type: "solid", //'dotted'虚线 'solid'实线
              opacity: 0.3
            },
            // data为列表，依次为month,height,heightIndex,tips,createdTimeStr
            data: this.standardHeight[this.form.gender].m3SD
          }
        ]
      });
      //console.log(this.form.birthday);
    },
    // 插入新的默认空白身高记录行
    addHeight() {
      this.form.patientHeight.push({
        value: "",
        key: Date.now(),
        treatment: 0,
      });
    },
    // 删除不要的身高记录行
    removeHeight(item) {
      var index = this.form.patientHeight.indexOf(item);
      if (index !== -1) {
        this.form.patientHeight.splice(index, 1);
      }
    },
    calHeightList() {
      //粗略计算
      // 先把身高数据按时间原位排序
      this.form.patientHeight.sort(function (a, b) {
        return a.time - b.time;
      });
      var gender = this.form.gender;
      for (var i = 0; i < this.form.patientHeight.length; i++) {
        var yearDiff =
          this.form.patientHeight[i].time.getFullYear() -
          this.form.birthday.getFullYear();
        var monthDiff =
          this.form.patientHeight[i].time.getMonth() -
          this.form.birthday.getMonth();
        var month = yearDiff * 12 + monthDiff;
        var height = this.form.patientHeight[i].value;
        // 保留1位小数
        var SD = this.height2SD(gender, month, height).toFixed(1);
        var height18 = this.height18(gender, SD).toFixed(1);
        // 计算当前身高距离中位值
        var heightMid = this.heightMid(gender, month, height).toFixed(1);
        // console.log(yearDiff * 12 + monthDiff);
        var treatment = this.form.patientHeight[i].treatment;
        this.heightList.push({
          value: [month, height, SD, height18, heightMid, treatment]
        });
      }
      // 已经排序好了，用最后一个的标准差来制作预测曲线
      // 画预测曲线时，如果有骨龄，则用 骨龄 和 年龄 较大那个作为年龄
      if (this.form.boneYear != null || this.form.boneMonth != null) {
        // console.log("有骨龄");
        var boneMonth = this.form.boneYear * 12 + this.form.boneMonth;
        if (boneMonth > month) {
          // console.log("骨龄大于年龄，按骨龄计算");
          month = boneMonth;
          // console.log("骨龄", month);
          // height 不变， heightList 最后一个弹出，重新计算
          var lastHeight = this.heightList.pop();
          var treatment = lastHeight[lastHeight.length - 1]
          var SD = this.height2SD(gender, month, height).toFixed(1);
          var height18 = this.height18(gender, SD).toFixed(1);
          // 计算当前身高距离中位值
          var heightMid = this.heightMid(gender, month, height).toFixed(1);
          // console.log(yearDiff * 12 + monthDiff);
          this.heightList.push({
            value: [month, height, SD, height18, heightMid, treatment]
          });
        }
      }
      // 计算预测曲线
      this.calHieghtPredictList(gender, month, SD);
      // 纠正数据，计算每个月的增加量;如果是男的，则打6折，女的打5折

      //console.log("纠正数据，", this.heightPredictList);
      var height = this.heightList[this.heightList.length - 1]["value"][1];
      //console.log("height", height);
      var diffList = [];
      // 勾上了再纠正数据
      if (this.form.short) {
        if (this.form.gender == 1) {
          var count = 0.6;
        }
        if (this.form.gender == 0) {
          var count = 0.5;
        }
      } else {
        var count = 1;
      }
      for (i = 0; i < this.heightPredictList.length; i++) {
        diffList.push((this.heightPredictList[i]["value"][1] - height) * count);
      }
      //console.log("diffList", diffList);
      // 加入预测部分的 SD、height18、heightMid 等数据
      var gender = this.form.gender;
      for (i = 0; i < this.heightPredictList.length; i++) {
        var heightPredict = height + diffList[i];
        this.heightPredictList[i]["value"][1] = heightPredict;
        var month = this.heightPredictList[i]["value"][0];
        var SD = this.height2SD(gender, month, heightPredict).toFixed(1);
        this.heightPredictList[i]["value"].push(SD);
        var height18 = this.height18(gender, SD).toFixed(1);
        this.heightPredictList[i]["value"].push(height18);
        var heightMid = this.heightMid(gender, month, heightPredict).toFixed(1);
        this.heightPredictList[i]["value"].push(heightMid);
      }

      // 输出预测数据，用生日计算年龄
      var today = new Date();
      var yearDiff = today.getFullYear() - this.form.birthday.getFullYear();
      var monthDiff = today.getMonth() - this.form.birthday.getMonth();
      var month = yearDiff * 12 + monthDiff;
      var year = Math.floor(month / 12);
      var month = month % 12;
      this.age = "约" + year + "岁" + month + "月";
      // console.log(this.heightList);
      // 计算末次测身高数据
      var lastCheckTime = this.form.patientHeight[
      this.form.patientHeight.length - 1
        ].time;
      this.lastCheck =
        lastCheckTime.getFullYear() +
        "年" +
        (lastCheckTime.getMonth() + 1) +
        "月" +
        lastCheckTime.getDate() +
        "日";
      // 把tooltip的内容再显示一遍
      // this.heightList.push({
      //       value: [month, height, SD, height18, heightMid]
      //     });
      // this.heightPredictList.push({
      //     value: [i, this.SD2height(gender, i, SD)]
      //   });
      // heightPredictList 开始和 heightList 最后一次对不上
      if (this.form.short) {
        for (var i = 0; i < this.heightList.length; i++) {
          this.heightList[i]["value"][3] = this.heightList[i]["value"][1] +
            count * (this.heightList[i]["value"][3] - this.heightList[i]["value"][1]);
          //console.log("身高", this.heightList[i]["value"][1], "18岁身高", this.heightList[i]["value"][3]);
        }
      }
      ;
      var height = this.heightList[this.heightList.length - 1]["value"][1];
      var heightMid = this.heightList[this.heightList.length - 1]["value"][4];
      var SD = this.heightList[this.heightList.length - 1]["value"][2];
      var height18 = this.heightList[this.heightList.length - 1][
        "value"
        ][3];
      this.tooltips =
        "身高" +
        height +
        "cm,该身高距离平均值" +
        heightMid +
        "cm,标准差为" +
        SD +
        "SD,18岁预测身高为" +
        height18 +
        "cm";
    },
    test() {
      // console.log(this.SD2height(0, 120, -2.2));
    },
    SD2height(gender, month, SD) {
      //SD 会变成字符串，导致计算错误
      SD = parseFloat(SD);
      var m3SD = standardHeight[gender]["m3SD"][month]["value"][1];
      var m2SD = standardHeight[gender]["m2SD"][month]["value"][1];
      var m1SD = standardHeight[gender]["m1SD"][month]["value"][1];
      var medium = standardHeight[gender]["medium"][month]["value"][1];
      var p1SD = standardHeight[gender]["p1SD"][month]["value"][1];
      var p2SD = standardHeight[gender]["p2SD"][month]["value"][1];
      var p3SD = standardHeight[gender]["p3SD"][month]["value"][1];
      var mediumMm1SD = medium - m1SD;
      if (SD >= 3) {
        return p3SD + (SD - 3) * mediumMm1SD;
      } else if (SD >= 2) {
        return p2SD + (SD - 2) * (p3SD - p2SD);
      } else if (SD >= 1) {
        return p1SD + (SD - 1) * (p2SD - p1SD);
      } else if (SD >= 0) {
        return medium + SD * (p1SD - medium);
      } else if (SD >= -1) {
        // console.log("m1SD", m1SD);
        // console.log("medium - m1sd", medium - m1SD);
        // console.log("SD + 1", SD + 1);
        // console.log("SD", SD);
        return m1SD + (SD + 1) * (medium - m1SD);
      } else if (SD >= -2) {
        return m2SD + (SD + 2) * (m1SD - m2SD);
      } else if (SD >= -3) {
        return m3SD + (SD + 3) * (m2SD - m3SD);
      } else {
        return m3SD + (SD + 3) * mediumMm1SD;
      }
    },
    height2SD(gender, month, height) {
      month = parseFloat(month);
      if (month > 216) {
        month = 216;
      }
      var m3SD = standardHeight[gender]["m3SD"][month]["value"][1];
      var m2SD = standardHeight[gender]["m2SD"][month]["value"][1];
      var m1SD = standardHeight[gender]["m1SD"][month]["value"][1];
      var medium = standardHeight[gender]["medium"][month]["value"][1];
      var p1SD = standardHeight[gender]["p1SD"][month]["value"][1];
      var p2SD = standardHeight[gender]["p2SD"][month]["value"][1];
      var p3SD = standardHeight[gender]["p3SD"][month]["value"][1];
      var mediumMm1SD = medium - m1SD;
      // console.log(m3SD, m2SD, m1SD, medium, p1SD, p2SD, p3SD);
      if (height >= p3SD) {
        return 3 + (height - p3SD) / mediumMm1SD;
      } else if (height >= p2SD) {
        return 2 + (height - p2SD) / (p3SD - p2SD);
      } else if (height >= p1SD) {
        return 1 + (height - p1SD) / (p2SD - p1SD);
      } else if (height >= medium) {
        return 0 + (height - medium) / (p1SD - medium);
      } else if (height >= m1SD) {
        return -1 + (height - m1SD) / (medium - m1SD);
      } else if (height >= m2SD) {
        return -2 + (height - m2SD) / (m1SD - m2SD);
      } else if (height >= m3SD) {
        return -3 + (height - m3SD) / (m2SD - m3SD);
      } else {
        return -3 - (m3SD - height) / mediumMm1SD;
      }
    },
    // 预测18岁身高
    height18(gender, SD) {
      SD = parseFloat(SD);
      return this.SD2height(gender, 216, SD);
    },
    // 计算身高距离中位数
    heightMid(gender, month, height) {
      height = parseInt(height);
      var medium = standardHeight[gender]["medium"][month]["value"][1];
      medium = parseInt(medium);
      return height - medium;
    },
    // 计算从下个月开始，标准差对应的身高，保存到heightPredictList
    calHieghtPredictList(gender, month, SD) {
      for (var i = month + 1; i <= 216; i++) {
        this.heightPredictList.push({
          value: [i, this.SD2height(gender, i, SD)]
        });
      }
    },
    // 计算遗传身高，父母身高平均值 ± 6.5
    calGeneticHeight() {
      var gender = this.form.gender;
      var fatherHeight = this.form.fatherHeight;
      var motherHeight = this.form.motherHeight;
      //todo: 有数值后又删掉，就不是 null 了 ？？？
      //console.log("fatherHeight ", fatherHeight);
      // console.log("motherHeight ", motherHeight);
      // console.log(fatherHeight === null);
      // console.log(motherHeight === null);
      if (fatherHeight === null) {
        return null;
      }
      if (motherHeight === null) {
        return null;
      }
      if (gender == 1) {
        this.geneticHeight = (fatherHeight + motherHeight) / 2 + 6.5;
      } else {
        this.geneticHeight = (fatherHeight + motherHeight) / 2 - 6.5;
      }
    },
    // 生成预测
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // console.log("submit");
          this.heightPredictList = [];
          // 清空保存处理后身高数据的列表
          this.heightList = [];
          this.geneticHeight = null;
          // 计算遗传身高
          this.calGeneticHeight();
          this.calHeightList();
          this.drawLine();
          this.generateReportId();
          // 显示 tooltips card 的显示
          this.visible = true;
          // 调试下治疗数据
          console.log(this.heightList);
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    save_patient_form(){
      pywebview.api.save_patient_form(this.form);
    },
    load_patient_form_by_id(){
      pywebview.api.load_patient_form_by_id(this.form.id).then(function(res){
        pywebview.api.log(res);
        console.log(res);
        if(Object.keys(res).length != 0){
          for(var key in res){
            this.form[key] = res[key]
          }
        }
      }),
      console.log("load patient form");
      console.log("this.form")
    },
    // 生成报告id
    generateReportId() {
      // 前面加16，再除以1000，就是时间戳了
      var d = new Date().valueOf();
      d = d % 100000000000;
      this.reportId = d.toString(16);
    },
    resetForm(formName) {
      this.heightList = [];
      this.$refs[formName].resetFields();
      //手动清空姓名和骨龄
      this.form.name = null;
      this.form.boneYear = null;
      this.form.boneMonth = null;
      this.form.patientHeight = [{
        value: "",
        key: Date.now(),
        treatment: 0,
      }];
      this.form.fatherHeight = null;
      this.form.motherHeight = null;
      this.heightPredictList = [];
      this.geneticHeight = null;
      this.drawLine();
      // 显示 tooltips card 的显示
      this.visible = false;
    }
  }
  // todo : 页面切换，是否存在echart未销毁导致的内存泄露？
};
</script>
<style>
html {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue